<script setup>
import { computed } from 'vue'

const baseUrl = import.meta.env.BASE_URL
const props = defineProps({
  icon: {
    type: String,
    required: true
  },

  color: {
    type: String,
    required: true
  }
})

const iconType = computed(() => props.icon ? props.icon.split('/')[0] : 'standard')
const iconName = computed(() => props.icon ? props.icon.split('/')[1] : 'settings')
const color = computed(() => props.color || '')
</script>
<template>
  <span
    :class="$attrs.class || 'w-8 h-8'"
    class="rounded inline-block bg-gray-300 dark:bg-gray-600"
    :style="{backgroundColor: color}"
  >
    <svg
      class="slds-icon fill-white"
      :class="$attrs.class || 'w-8 h-8'"
      aria-hidden="true"
    >
      <use :xlink:href="`${baseUrl}/slds-icons/${iconType}/symbols.svg#${iconName}`" />
    </svg>
  </span>
</template>
